import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useGlobalContext } from "../../shared/context/global.context";
import { usePresentacionContext } from "../context/presentacion.context";
import {
  DOCU,
  INICIADA_COMERCIO,
  SUCCESS_CONSULTAR_PARAMETROS_PRESENTACION,
  SUCCESS_GET_IVA_COMERCIO,
} from "../utilities/constants";
import {
  getSituacionIvaComercio,
} from "../services/comercio.service";
import CustomInput from "./PresentacionesCustomInput";
import { consultarTasaIvaSegunInscripcion } from "../services/facturas.service";
import { consultarParametrosPresentacion } from "../services/presentaciones.services";

const PresentacionesDatosGenerales = () => {
  const { comercioSelecionado } = useGlobalContext();
  const {
    presentacion,
    situacionIvaComercio,
    setSituacionIvaComercio,
    setTasasIVA,
    setParametrosPresentacion,
    productosComercio,
    selectedProductoComercio, setSelectedProductoComercio,
    presentacionComercio,
    setShowMask,transaccionesSeleccionadas,
    setShowDetailTransaction,
    detailsTxSeleccionadas
  } = usePresentacionContext();
  const [spinnerSituacionIvaComercio, setSpinnerSituacionIvaComercio] =  useState(true);
  const [spinnerPresentacion, setSpinnerPresentacion] = useState(false);
  const [showDropdownServicio,setShowDropdownServicio] = useState(false)

  useEffect(() => {
    (async () => {
      if (comercioSelecionado.length === 0) return;
      const result = await getSituacionIvaComercio();
      if (result.status === 200) {
        if (result.data.tipoInscripcion.length > 0) {
          const {data, status}  = await consultarTasaIvaSegunInscripcion(
            result.data.tipoInscripcion[0].tic_code
          );
          setTasasIVA(data.tipoInscripcion);
          setSituacionIvaComercio(result.data.tipoInscripcion);
          setSpinnerSituacionIvaComercio(false);
        }
      }
      const {data, status}  = await consultarParametrosPresentacion(
        DOCU,
        ""
      );
      if (status === 200) {
        setParametrosPresentacion(data.parametros);
      }
    })();
  }, [comercioSelecionado]);

  useEffect(() => {
    (detailsTxSeleccionadas.length == 0 && transaccionesSeleccionadas.length == 0 )? setShowDropdownServicio(true) : setShowDropdownServicio(false)
    
  }, [transaccionesSeleccionadas,detailsTxSeleccionadas])
  

  const onProductoComercioChange = (e: any) => {
    setShowDetailTransaction(false)
    setShowMask(true)
    setSelectedProductoComercio(e.value);
  };

  return (
    <>
      <div className="p-grid p-justify-even p-align-center mt-2">
        <div className="p-col-12  p-lg-3 mt-2">
          <div className="p-inputgroup" style={{ alignItems: "baseline" }}>
            <CustomInput
              id="IVA"
              value={
                situacionIvaComercio.length > 0
                  ? situacionIvaComercio[0].tic_label
                  : ""
              }
              label="Situación IVA:"
              loader={spinnerSituacionIvaComercio}
            />
          </div>
        </div>
        <div className="p-col-12  p-lg-3 mt-2">
          <div className="p-inputgroup" style={{ alignItems: "baseline" }}>
            <CustomInput
              id="numPresentacion"
              value={presentacion !== 0 ? String(presentacion) : ""}
              label="Presentación Nº:"
              loader={spinnerPresentacion}
            />
          </div>
        </div>

        <div className="p-col-12  p-lg-3 mt-2">
          <div className="p-inputgroup" style={{ alignItems: "baseline" }}>
            <CustomInput
              id="estado"
              value={presentacionComercio.descripcion}
              label="Estado:"
              loader={spinnerPresentacion}
            />
          </div>
        </div>
        <div className="p-col-12 p-lg-3 mt-2">
          {(productosComercio.length > 1 && presentacionComercio.descripcion === INICIADA_COMERCIO && showDropdownServicio) ? (
            <span className="p-float-label">
              <Dropdown
                id="grupoproductos"
                value={selectedProductoComercio}
                options={productosComercio}
                onChange={onProductoComercioChange}
                optionLabel="grupoProductoNombre"
                placeholder=""
                style={{
                  maxWidth: "100%",
                  marginLeft: "6px",
                  padding: "0.4vw",
                  backgroundColor: "#f4fafe",
                }}
                //disabled={presentacionComercio.descripcion !== INICIADA_COMERCIO}
              />
              <label
                htmlFor="grupoproductos"
                style={{ minWidth: "120px", fontSize: "12px", top: "-0.75rem" }}
              >
                Servicio:
              </label>
            </span>
          ) : (
            <div className="p-inputgroup" style={{ alignItems: "baseline" }}>
              <CustomInput
                id="producto"
                value={
                  selectedProductoComercio &&
                  Object.keys(selectedProductoComercio).length > 0
                    ? selectedProductoComercio.grupoProductoNombre.toUpperCase()
                    : ""
                }
                label="Servicio:"
                loader={false}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PresentacionesDatosGenerales;
